<div class="wrapper-list-stores">
  <div class="section-title">
    <div class="row">
      <div class="col">
        <div class="d-flex align-items-center">
          <div class="title">{{ "Express Checkout" | translate }}</div>
        </div>
      </div>
      <div class="col text-right">
        <div class="d-inline-block">
          <button
            class="btn btn-primary ui-classic-only"
            routerLink="/dashboard/express-checkout-create"
          >
            {{ "Create checkout link" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!--<div class="section-title row">
    <div class="section-btn">
      <button
        routerLink="/dashboard/overview"
        class="btn btn-back rounded-circle mt-2"
      >
        <i class="fi-rr-arrow-alt-left"></i>
      </button>
    </div>
    <div>
      <div class="title">{{ "Express Checkout" | translate }}</div>
    </div>
    <div class="d-inline-block w-100">
      <button
        class="btn btn-outline-primary"
        routerLink="/dashboard/express-checkout-create"
        (click)="createNew()"
      >
        {{ "Create checkout link" | translate }}
      </button>
    </div>
  </div>-->

  <div class="checkout-toolbar mb-4">
    <div class="filter-options">
      <!-- Platform Dropdown -->
      <div ngbDropdown class="d-inline-block">
        <button
          class="btn btn-filter"
          [class.active]="selectedPlatformType && selectedPlatformType.value !== 'ALL'"
          id="dropdownBasicPlatform"
          ngbDropdownToggle
        >
          <i class="fi fi-rr-settings-sliders mr-1"></i>
          <span>
            {{ selectedPlatformType?.value !== 'ALL' && selectedPlatformType?.display ? selectedPlatformType.display : ("Platform" | translate) }}
          </span>
        </button>
        <div
          ngbDropdownMenu
          aria-labelledby="dropdownBasicPlatform"
          class="custom-dropdown"
        >
          <button
            ngbDropdownItem
            *ngFor="let filter of platformTypeFilters"
            (click)="selectedPlatformType = filter"
          >
            {{ filter.value === 'ALL' ? ("View All" | translate) : (filter.display || filter.value) }}
          </button>
        </div>
      </div>

      <!-- Source Dropdown -->
      <div ngbDropdown class="d-inline-block">
        <button
          class="btn btn-filter"
          [class.active]="selectedOrderType && selectedOrderType.value !== 'ALL'"
          id="dropdownBasicSource"
          ngbDropdownToggle
        >
          <i class="fi fi-rr-apps mr-1"></i>
          <span>
            {{ selectedOrderType?.value !== 'ALL' && selectedOrderType?.display && selectedOrderType?.display !== 'View All' ? selectedOrderType.display : ("Source" | translate) }}
          </span>
        </button>
        <div
          ngbDropdownMenu
          aria-labelledby="dropdownBasicSource"
          class="custom-dropdown"
        >
          <button
            ngbDropdownItem
            *ngFor="let filter of orderTypeFilters"
            (click)="selectedOrderType = filter"
          >
            {{ "{0}" | translate: [utils.translate(filter.display)] }}
          </button>
        </div>
      </div>
    </div>

    <!-- Search, and (glass theme) the create button on its right -->
    <div class="toolbar-end d-flex align-items-center gap-2">
      <div class="search-box">
        <input
          type="text"
          class="form-control"
          [(ngModel)]="searchNameData"
          (ngModelChange)="onSearchChange()"
          placeholder="{{ 'Search by Name' | translate }}"
        />
        <i class="fi fi-rr-search search-icon"></i>
        <i class="fas fa-times clear-icon" *ngIf="searchNameData" (click)="clearSearch()"></i>
      </div>
      <button
        class="btn btn-primary ui-glass-only toolbar-create-btn"
        routerLink="/dashboard/express-checkout-create"
      >
        {{ "Create checkout link" | translate }}
      </button>
    </div>
  </div>

  <div class="section-main">
    <div class="row" *ngIf="dataIsLoading; else loadedContent">
      <div class="loading-spinner col-12 mt-5">
        <mat-spinner class="mx-auto mt-5" [diameter]="50"></mat-spinner>
      </div>
    </div>

    <ng-template #loadedContent>
      <div class="empty-data col-12" *ngIf="!filteredOrderHistoryList?.length">
        <img class="icon-style-1" src="/assets/empty-box.png" />
        <h3>{{ "No Order Found" | translate }}</h3>
        <p ng-ht>
          {{
            "We couldn't find any order data for the selected filter."
              | translate
          }}
          <br />
          {{ "Trychange the filter?" | translate }}
        </p>
      </div>

      <div class="row order-card my-2" *ngIf="checkout_list?.length != 0">
        <div class="col-lg-12 col-sm-12">
          <div
            class="card my-2"
            style="width: 100% !important"
            *ngFor="let data of filteredOrderHistoryList; let i = index"
          >
            <div class="row align-items-center">
              <!-- title & country -->
              <div class="col-lg-5 col-md-4 col-12">
                <div class="list-info-group flex flex-auto align-items-center">
                  <div class="text-left">
                    <div
                      #tooltip="matTooltip"
                      [matTooltip]="getCountryName(data?.country_code)"
                      matTooltipPosition="above"
                      matTooltipHideDelay="100"
                      class="rounded-full border-2 border-white relative shadow overflow-hidden bg-white mr-3"
                    >
                      <img
                        [src]="getFlagImageURL(data?.country_code)"
                        class="object-cover w-6 h-6 min-w-[1.5rem]"
                      />
                    </div>
                  </div>
                  <div class="text-left leading-tight">
                    <p class="value-text title-text font-weight-bold">
                      {{ data?.page_title }}
                    </p>
                    <span *ngIf="hasProductLink(data)"
                      class="inline-flex items-center gap-1 mt-1 px-2 py-0.5 rounded-full text-xs font-medium border text-indigo-600 bg-indigo-50 border-indigo-100">
                      <i class="fi fi-rr-link-alt"></i>
                      {{ "Enable Product Link" | translate }}
                    </span>
                    <div
                      *ngIf="
                        data?.page_subtitle !== undefined &&
                        data?.page_subtitle !== ''
                      "
                    >
                      <p class="subtitle-text mt-2">
                        {{ data?.page_subtitle }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- datetime -->
              <div class="col-lg-3 col-md-3 col-12 text-md-center text-left my-2 my-md-0">
                <div>
                  <p
                    class="mb-0 text-sm"
                    #tooltip="matTooltip"
                    matTooltip="Created on {{
                      data.created_at | date: 'medium'
                    }}"
                    matTooltipPosition="above"
                    matTooltipHideDelay="100"
                  >
                    {{ data.created_at | timeago: true }}
                  </p>
                  <p
                    *ngIf="data.updated_at !== data.created_at"
                    #tooltip="matTooltip"
                    matTooltip="Edited on {{
                      data.updated_at | date: 'medium'
                    }}"
                    matTooltipPosition="above"
                    matTooltipHideDelay="100"
                    class="text-slate-400 text-xs mt-1 mb-0"
                  >
                    {{ "Edited" | translate }}
                    {{ data.updated_at | timeago: true }}
                  </p>
                </div>
              </div>

              <!-- actions -->
              <div class="col-lg-4 col-md-5 col-12">
                <div class="page-action-group">
                  <button
                    type="button"
                    class="btn-action btn-action-view"
                    (click)="openLink(openlink, data, 'view')"
                  >
                    <i class="fi fi-rr-link-alt"></i>
                    <span>{{ "View links" | translate }}</span>
                  </button>

                  <button
                    *ngIf="
                      data?.link_type != 5 &&
                      data?.link_type != 7 &&
                      (!(data?.link_type == 4 && !twSubscriptionStatus) ||
                        data.subscription_type === 'biannual' ||
                        data.subscription_type === 'subscription')
                    "
                    type="button"
                    class="btn-action btn-action-edit"
                    (click)="edit(data.url, data.country_code)"
                  >
                    <i class="fi fi-rr-edit"></i>
                    <span>{{ "Edit" | translate }}</span>
                  </button>

                  <button
                    *ngIf="
                      !isStoreInfoLoading &&
                      !isSvoStore &&
                      (data?.link_type == 1 ||
                        data?.link_type == 2 ||
                        data?.order_type_id == 1 ||
                        data?.order_type_id == 2 ||
                        data?.subscription_type === 'subscription')
                    "
                    type="button"
                    class="btn-action-icon btn-action-share"
                    (click)="openLink(openlink, data, 'share')"
                    #tooltip="matTooltip"
                    matTooltip="{{
                      'Share to Social Media in Nexus' | translate
                    }}"
                    matTooltipPosition="above"
                    matTooltipHideDelay="100"
                    aria-label="Share"
                  >
                    <i class="fi fi-rr-share"></i>
                  </button>

                  <button
                    *ngIf="data?.link_type != 5 && data?.link_type != 7"
                    type="button"
                    class="btn-action-icon btn-action-delete"
                    (click)="open(content, data)"
                    #tooltip="matTooltip"
                    matTooltip="{{ 'Delete' | translate }}"
                    matTooltipPosition="above"
                    matTooltipHideDelay="100"
                    aria-label="Delete"
                  >
                    <i class="fi fi-rr-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div
            class="pagination-container row align-items-center px-4 py-3"
            *ngIf="filterList?.length != 0"
          >
            <div class="col-md-6 col-12 d-flex justify-content-md-start justify-content-center mb-2 mb-md-0">
              <ngb-pagination
                [collectionSize]="filterList.length"
                [(page)]="page"
                [pageSize]="selectedPage"
                aria-label="Default pagination"
                (pageChange)="changePage($event)"
                [ellipses]="false"
                [rotate]="true"
                [maxSize]="5"
              ></ngb-pagination>
            </div>
            <div class="col-md-6 col-12 d-flex justify-content-md-end justify-content-center">
              <div class="pagination-info text-center text-md-right">
                {{ "Showing" | translate }} <b>{{ start + 1 }}–{{ end }}</b> {{ "of" | translate }}
                <b>{{ filterList.length }}</b>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #openlink let-modal>
      <div class="links-modal-container">
        <div class="modal-header d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <div class="modal-header-icon mr-3">
              <i class="fi fi-rr-link-alt"></i>
            </div>
            <div>
              <h5 class="modal-title mb-0 font-weight-bold">
                {{ (modalMode === 'share' ? "Share Checkout Links" : "Checkout Links") | translate }}
              </h5>
              <div class="d-flex align-items-center flex-wrap gap-2 mt-1">
                <p class="text-muted text-xs mb-0 font-weight-500" *ngIf="link_data?.page_title">
                  {{ link_data?.page_title }}
                </p>
                <span class="text-muted text-xs" *ngIf="link_data?.page_title && (getModalLanguages() || link_data?.created_at || link_data?.updated_at)">•</span>
                <span class="text-muted text-xs font-weight-500" *ngIf="getModalLanguages()">
                  <i class="fi fi-rr-globe mr-1"></i>{{ getModalLanguages() }}
                </span>
                <span class="text-muted text-xs" *ngIf="link_data?.created_at">
                  <span *ngIf="getModalLanguages()">• </span>{{ "Created" | translate }}: {{ link_data?.created_at | timeago : true }}
                </span>
                <span class="text-muted text-xs" *ngIf="link_data?.updated_at && link_data?.updated_at !== link_data?.created_at">
                  • {{ "Edited" | translate }}: {{ link_data?.updated_at | timeago : true }}
                </span>
              </div>
            </div>
          </div>
          <button
            type="button"
            class="btn-close-modal"
            aria-label="Close"
            (click)="modal.dismiss('Cross click')"
          >
            <i class="fi fi-rr-cross-small"></i>
          </button>
        </div>

        <div class="modal-body p-3 p-md-4">
          <div class="loading-spinner py-5 text-center" *ngIf="loading">
            <mat-spinner class="mx-auto" [diameter]="42"></mat-spinner>
          </div>

          <!-- Empty State -->
          <div
            class="text-center py-5 empty-links"
            *ngIf="(!link_list || link_list.length === 0) && !loading"
          >
            <div class="empty-icon mb-3">
              <i class="fi fi-rr-link-slash"></i>
            </div>
            <h6 class="font-weight-bold text-secondary">{{ "No links found" | translate }}</h6>
            <p class="text-muted text-xs mb-0">
              {{ "No checkout links available for this page." | translate }}
            </p>
          </div>

          <!-- Links Cards List -->
          <div
            class="link-list-wrapper"
            *ngIf="link_list?.length > 0 && !loading"
          >
            <ng-container *ngFor="let listdata of link_list; let i = index">
              <!-- Direct Express URL Card -->
              <div class="link-item-card">
                <div class="link-item-main">
                  <div class="url-container mt-0">
                    <a
                      [href]="listdata?.express_url"
                      target="_blank"
                      class="url-text"
                      #tooltip="matTooltip"
                      matTooltip="{{ 'Click to open in new tab' | translate }}"
                      matTooltipPosition="above"
                      matTooltipHideDelay="100"
                    >
                      <span class="url-string">{{ listdata?.express_url }}</span>
                      <i class="fi fi-rr-arrow-small-right ml-1"></i>
                    </a>
                  </div>
                </div>

                <div class="link-item-actions">
                  <button
                    type="button"
                    class="btn-link-action btn-copy"
                    (click)="utils.copyToClipboard(listdata?.express_url, 'The link')"
                    #tooltip="matTooltip"
                    matTooltip="{{ 'Copy URL to clipboard' | translate }}"
                    matTooltipPosition="above"
                    matTooltipHideDelay="100"
                  >
                    <i class="las la-copy"></i>
                    <span>{{ "Copy" | translate }}</span>
                  </button>

                  <a
                    [href]="listdata?.express_url"
                    target="_blank"
                    class="btn-link-action btn-preview"
                    #tooltip="matTooltip"
                    matTooltip="{{ 'Open checkout in browser' | translate }}"
                    matTooltipPosition="above"
                    matTooltipHideDelay="100"
                  >
                    <i class="fi fi-rr-eye"></i>
                    <span>{{ "Open" | translate }}</span>
                  </a>

                  <button
                    *ngIf="
                      !isStoreInfoLoading &&
                      !isSvoStore &&
                      modalMode === 'share' &&
                      (link_data?.link_type == 1 ||
                        link_data?.link_type == 2 ||
                        link_data?.order_type_id == 1 ||
                        link_data?.order_type_id == 2)
                    "
                    type="button"
                    class="btn-link-action btn-analytics"
                    (click)="share(listdata)"
                    #tooltip="matTooltip"
                    matTooltip="{{ 'Share to Social Media in Nexus' | translate }}"
                    matTooltipPosition="above"
                    matTooltipHideDelay="100"
                  >
                    <i class="fi fi-rr-share"></i>
                    <span>{{ "Share" | translate }}</span>
                  </button>
                </div>
              </div>

              <!-- Product Link Card (if domain_url exists) -->
              <div class="link-item-card" *ngIf="listdata?.domain_url">
                <div class="link-item-main">
                  <div class="d-flex align-items-center mb-2 flex-wrap gap-2">
                    <span class="visibility-badge published">
                      <i class="fi fi-rr-link-alt"></i>
                      <span>{{ "Product Link" | translate }}</span>
                    </span>
                  </div>

                  <div class="url-container">
                    <a
                      [href]="productGoUrl(listdata?.domain_url)"
                      target="_blank"
                      class="url-text"
                      #tooltip="matTooltip"
                      matTooltip="{{ 'Click to open in new tab' | translate }}"
                      matTooltipPosition="above"
                      matTooltipHideDelay="100"
                    >
                      <span class="url-string">{{ productGoUrl(listdata?.domain_url) }}</span>
                      <i class="fi fi-rr-arrow-small-right ml-1"></i>
                    </a>
                  </div>
                </div>

                <div class="link-item-actions">
                  <button
                    type="button"
                    class="btn-link-action btn-copy"
                    (click)="utils.copyToClipboard(productGoUrl(listdata?.domain_url), 'The link')"
                    #tooltip="matTooltip"
                    matTooltip="{{ 'Copy URL to clipboard' | translate }}"
                    matTooltipPosition="above"
                    matTooltipHideDelay="100"
                  >
                    <i class="las la-copy"></i>
                    <span>{{ "Copy" | translate }}</span>
                  </button>

                  <a
                    [href]="productGoUrl(listdata?.domain_url)"
                    target="_blank"
                    class="btn-link-action btn-preview"
                    #tooltip="matTooltip"
                    matTooltip="{{ 'Open link in browser' | translate }}"
                    matTooltipPosition="above"
                    matTooltipHideDelay="100"
                  >
                    <i class="fi fi-rr-eye"></i>
                    <span>{{ "Open" | translate }}</span>
                  </a>

                  <button
                    *ngIf="
                      !isStoreInfoLoading &&
                      !isSvoStore &&
                      modalMode === 'share' &&
                      (link_data?.link_type == 1 ||
                        link_data?.link_type == 2 ||
                        link_data?.order_type_id == 1 ||
                        link_data?.order_type_id == 2)
                    "
                    type="button"
                    class="btn-link-action btn-analytics"
                    (click)="shareProductLink(listdata)"
                    #tooltip="matTooltip"
                    matTooltip="{{ 'Share to Social Media in Nexus' | translate }}"
                    matTooltipPosition="above"
                    matTooltipHideDelay="100"
                  >
                    <i class="fi fi-rr-share"></i>
                    <span>{{ "Share" | translate }}</span>
                  </button>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="modal-footer d-flex justify-content-end align-items-center p-3">
          <button
            type="button"
            class="btn btn-secondary px-4 py-2 text-sm rounded-lg"
            (click)="modal.dismiss('Cross click')"
          >
            {{ "Close" | translate }}
          </button>
        </div>
      </div>
    </ng-template>

    <ng-template #content let-modal>
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">
          {{ "Delete List" | translate }}
        </h4>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="text-secondary">
          {{ "Are you sure you want to delete this List?" | translate }}
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-primary"
          (click)="modal.close('Save click')"
        >
          {{ "Cancel" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-red"
          (click)="modal.close('delete')"
        >
          {{ "Delete" | translate }}
        </button>
      </div>
    </ng-template>

    <ng-template #success let-modal>
      <div class="modal-body text-center">
        <div class="row" align="center">
          <div class="col pt-4 pt-lg-0">
            <h4>{{ "Successfully Update" | translate }}</h4>
          </div>
        </div>
        <button
          class="btn btn-primary"
          type="button"
          name="button"
          (click)="modal.close('Send click')"
        >
          {{ "Close" | translate }}
        </button>
      </div>
    </ng-template>
  </div>
</div>
